module.exports = __webpack_public_path__ + "img/PAN.d536aade.svg";